import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.15, ease: 'easeOut' }}
      className="flex flex-col min-h-screen bg-background"
    >
      <main className="flex-1 overflow-y-auto pb-20 px-4 pt-4 safe-area-top">
        {children}
      </main>
    </motion.div>
  );
}
